export var FactoryType;
(function (FactoryType) {
    FactoryType["DynamicValue"] = "toDynamicValue";
    FactoryType["Factory"] = "toFactory";
    FactoryType["Provider"] = "toProvider";
})(FactoryType || (FactoryType = {}));
//# sourceMappingURL=factory_type.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/inversify/es/utils/factory_type.js
// module id = 1720
// module chunks = 0